import React from "react";
import { connect } from "react-redux";

import { IAppState } from "../../state/Store";

interface MessagingBroadcastCloseProps {
    isSystem: boolean;
    broadcasting: boolean;
    clearThread: () => void;
}

class MessagingBroadcastClose extends React.Component<MessagingBroadcastCloseProps> {
    render(): React.ReactNode {
        return (
            this.props.isSystem &&
            !this.props.broadcasting && (
                <div className="col-pane message-close">
                    <input
                        className="action-button full bottom-clearance-small"
                        type="button"
                        value="Close"
                        style={{
                            marginLeft: 0,
                            marginRight: 0,
                        }}
                        onClick={this.props.clearThread}></input>
                </div>
            )
        );
    }
}

const mapStateToProps = (state: IAppState) => {
    return {};
};

const mapDispatchToProps = dispatch => {
    return {};
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(MessagingBroadcastClose);
